import {ValueDefinition} from '@/model/types';

export const enum T2033Requirement {
  YES = 'DV-42#0',
  NO_OTHER_FORM = 'DV-42#1',
}

export const DV_42 = {
  id: 'DV-42',
  description: {
    fr: 'Production d’un T2033?',
    en: 'Fill out a T2033?',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Oui',
        en: 'Yes',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Non (autre formulaire)',
        en: 'No (other form)',
      },
    },
  ],
} as const satisfies ValueDefinition;
